import { createContext } from "react";
import useLotsByProjectIdStageId from "../../hooks/data/useLotsByProjectIdStageId";

export interface ILotsContext extends ReturnType<typeof useLotsByProjectIdStageId> {
}

export const LotsContext = createContext<ILotsContext>({
    data: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default LotsContext;